import { fetch } from '@/shared/fetch';

export const setConsultationDemandingStatus = async (
    consultationUid: string,
    isParticularlyDemanding: boolean,
): Promise<void> => {
    return await fetch(
        `/api/caregiverspace/consultations/${consultationUid}/particularly-demanding`,
        'POST',
        { IsParticularlyDemanding: isParticularlyDemanding },
    );
};
